/** Shared loading / empty / error placeholders. */

import { el } from "../lib/dom";

export function loadingState(label = "Loading…"): HTMLElement {
  return el("div", {
    className: "state state--loading",
    attrs: { role: "status", "aria-live": "polite" },
    children: [el("span", { className: "state__spinner", attrs: { "aria-hidden": "true" } }), el("p", { text: label })],
  });
}

export function emptyState(title: string, detail?: string): HTMLElement {
  return el("div", {
    className: "state state--empty",
    children: [
      el("p", { className: "state__title", text: title }),
      detail === undefined ? null : el("p", { className: "state__detail", text: detail }),
    ],
  });
}

export interface ErrorStateOptions {
  readonly message: string;
  readonly onRetry?: () => void;
}

export function errorState(options: ErrorStateOptions): HTMLElement {
  return el("div", {
    className: "state state--error",
    attrs: { role: "alert" },
    children: [
      el("p", { className: "state__title", text: "Something went wrong" }),
      el("p", { className: "state__detail", text: options.message }),
      options.onRetry === undefined
        ? null
        : el("button", {
            className: "button button--secondary",
            attrs: { type: "button" },
            text: "Try again",
            on: { click: options.onRetry },
          }),
    ],
  });
}
